export const toNum = (value) => {
  const n = parseInt(value);
  return isNaN(n) ? 0 : n;
};

export const parseDate = (value) => {
  if (!value) return null;
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [y, m, d] = value.split("-").map(Number);
    return new Date(y, m - 1, d);
  }
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
};

export const inDateRange = (value, from, to) => {
  const f = parseDate(from);
  const t = parseDate(to);
  if (!f && !t) return true;
  const d = parseDate(value);
  if (!d) return false;
  if (f && d < f) return false;
  if (t) {
    const end = new Date(t);
    end.setHours(23, 59, 59, 999);
    if (d > end) return false;
  }
  return true;
};

export const daysAgo = (days) => {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() - days);
  return d;
};

export const isWithinLastDays = (value, days) => {
  const d = parseDate(value);
  if (!d) return false;
  return d >= daysAgo(days) && d <= new Date();
};

export const genderProject = (gender) =>
  gender === "Female" ? "Miriam" : "Moses";

export const matchesProject = (gender, projects) => {
  if (!Array.isArray(projects) || projects.length === 0) return false;
  return projects.includes(genderProject(gender));
};

export const matchesDailyProject = (row, projects) => {
  if (!Array.isArray(projects) || projects.length === 0) return false;
  const male = toNum(row.male);
  const female = toNum(row.female);
  const others = toNum(row.others);
  const mosesActive =
    male + others > 0 ||
    toNum(row.mosesStarter) > 0 ||
    toNum(row.mosesFood) > 0;
  const miriamActive =
    female > 0 || toNum(row.miriamStarter) > 0 || toNum(row.miriamFood) > 0;
  return (
    (projects.includes("Moses") && mosesActive) ||
    (projects.includes("Miriam") && miriamActive)
  );
};

export const yesNo = (value) => {
  if (value === true) return "Yes";
  if (value === false) return "No";
  if (value === "yes" || value === "Yes") return "Yes";
  if (value === "no" || value === "No") return "No";
  return value || "";
};
